import "core-js/modules/es6.function.name";
//
//
//
//
import echarts from 'echarts';
import 'echarts/lib/chart/gauge';
import 'echarts/lib/component/tooltip';
import 'echarts/lib/component/title';
export default {
  props: {
    width: {
      type: String,
      default: '95%'
    },
    height: {
      type: String,
      default: '85%'
    },
    top: {
      type: String,
      default: '0px'
    },
    left: {
      type: String,
      default: '0'
    }
  },
  data: function data() {
    return {
      chart: 'chart10'
    };
  },
  mounted: function mounted() {// setTimeout(() => {
    //   this.initBarChart()
    // }, 1000)
    // this.$nextTick(() => {})
  },
  methods: {
    initBarChart: function initBarChart(salvProValue, salvProName, sum) {
      var salvProMax = []; //背景按最大值

      for (var i = 0; i < salvProValue.length; i++) {
        salvProMax.push(salvProValue[0]);
      }

      var option = option = {
        grid: {
          left: "2%",
          right: "2%",
          bottom: "2%",
          top: "2%",
          containLabel: true
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "none"
          },
          formatter: function formatter(params) {
            return params[0].name + " : " + params[0].value;
          }
        },
        xAxis: {
          show: false,
          type: "value"
        },
        yAxis: [{
          type: "category",
          inverse: true,
          axisLabel: {
            show: true,
            textStyle: {
              color: "#fff"
            }
          },
          splitLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          axisLine: {
            show: false
          },
          data: salvProName
        }, {
          type: "category",
          inverse: true,
          axisTick: "none",
          axisLine: "none",
          show: true,
          axisLabel: {
            textStyle: {
              color: "#ffffff",
              fontSize: "10"
            }
          },
          data: salvProValue
        }],
        series: [{
          name: "值",
          type: "bar",
          zlevel: 1,
          itemStyle: {
            normal: {
              barBorderRadius: 10,
              color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [{
                offset: 0,
                color: "rgb(57,89,255,1)"
              }, {
                offset: 1,
                color: "rgb(46,200,207,1)"
              }])
            }
          },
          barWidth: 10,
          data: salvProValue
        }, {
          name: "背景",
          type: "bar",
          barWidth: 10,
          barGap: "-100%",
          data: salvProMax,
          itemStyle: {
            normal: {
              color: "rgba(24,31,68,1)",
              barBorderRadius: 30
            }
          }
        }]
      };
      var chart = this.$refs[this.chart];
      var myChart = this.$echarts.init(chart);
      myChart.setOption(option);
      window.addEventListener('resize', function () {
        myChart.resize();
      });
    }
  }
};